import React, { lazy } from 'react';
export function HeroSection() {
  return <section className="w-full py-16 md:py-24 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12 md:gap-20" data-id="element-89">
      <div className="flex-1 flex flex-col items-start text-left" data-id="element-90">
        <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl leading-tight text-dark mb-6" data-id="element-91">
          <span className="block" data-id="element-92">
            Así como heredaste el color de tus ojos…
          </span>
          <span className="block text-terracotta mt-2" data-id="element-93">
            también heredaste tus bloqueos emocionales.
          </span>
        </h1>
        <p className="text-lg md:text-xl text-dark/80 font-light mb-10 max-w-xl leading-relaxed" data-id="element-94">
          Descubre por qué repites patrones que no comenzaron contigo… y cómo
          liberarte.
        </p>
        <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 bg-terracotta text-white font-medium rounded-full hover:bg-terracotta-hover transition-colors duration-300 shadow-lg shadow-terracotta/20" data-id="element-95">
          Quiero dejar de repetir esto de una vez →
        </a>
      </div>
      <div className="flex-1 w-full flex justify-center md:justify-end" data-id="element-96">
        <img src="https://cdn.magicpatterns.com/uploads/6AAZcvnqYm3PGBjEnsVSfr/39dd6d05-e3fc-4fa2-be9f-f41370fff4ac.png" alt="Mujer mirándose al espejo con luz cálida" loading="lazy" className="w-full max-w-md rounded-2xl shadow-2xl shadow-dark/10 object-cover aspect-[3/4]" data-id="element-97" />
      </div>
    </section>;
}